import { collection, doc, getDocs, setDoc, query, where } from "firebase/firestore";
import { db } from "../config/firebase";

const COLLECTION = "diemDanh";
const generateId = (lopId, hocSinhId, ngayHoc) => lopId + '_' + hocSinhId + '_' + ngayHoc;

// ✅ Đã có
export const getDiemDanhByNgay = async (lopId, ngay) => {
  const q = query(collection(db, COLLECTION), where("lopId", "==", lopId), where("ngayHoc", "==", ngay));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// ✅ Đã có
export const luuDiemDanh = async (data) => {
  const id = generateId(data.lopId, data.hocSinhId, data.ngayHoc);
  await setDoc(doc(db, COLLECTION, id), { ...data, ngayCapNhat: new Date().toISOString() }, { merge: true });
};

// ✅ Đã có
export const luuNhieuDiemDanh = async (danhSach) => {
  await Promise.all(danhSach.map(item => luuDiemDanh(item)));
};

// ===== 🆕 THÊM MỚI =====

// Lấy Chúa Nhật gần nhất (kể cả hôm nay nếu là CN)
export const getCurrentSunday = () => {
  const now = new Date();
  const day = now.getDay(); // 0 = Chủ Nhật
  const diff = now.getDate() - day; // Lùi về CN tuần này
  const sunday = new Date(now.setDate(diff));
  return sunday.toISOString().split('T')[0]; // yyyy-mm-dd
};

// Đếm số HS CHƯA điểm danh ngày gần nhất trong 1 lớp
export const countChuaDiemDanh = async (lopId) => {
  const ngay = getCurrentSunday();
  const q = query(collection(db, COLLECTION), where("lopId", "==", lopId), where("ngayHoc", "==", ngay));
  const snapshot = await getDocs(q);
  return snapshot.size; // Số đã điểm danh → cần tổng HS - số này
};

// Đếm số HS vắng không phép hôm nay (cho badge cảnh báo)
export const countVangKhongPhep = async (lopId) => {
  const ngay = getCurrentSunday();
  const q = query(
    collection(db, COLLECTION),
    where("lopId", "==", lopId),
    where("ngayHoc", "==", ngay),
    where("trangThai", "==", "vangKhongPhep")
  );
  const snapshot = await getDocs(q);
  return snapshot.size;
};